import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { FeedAlgorithm } from 'src/app/core/models/algorithm.models';

@Component({
  selector: 'app-algorithm-picker',
  templateUrl: './algorithm-picker.component.html',
  styleUrls: ['./algorithm-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlgorithmPickerComponent {
  @Input() algorithms: FeedAlgorithm[] = [];

  @Output() selectionChange = new EventEmitter<number[]>();

  selectedIds = new Set<number>();

  isSelected(id: number): boolean {
    return this.selectedIds.has(id);
  }

  toggle(algorithm: FeedAlgorithm, selected: boolean): void {
    if (selected) {
      this.selectedIds.add(algorithm.id);
    } else {
      this.selectedIds.delete(algorithm.id);
    }
    this.selectionChange.emit(Array.from(this.selectedIds));
  }
}
